const Customer = {
  id: 'CustomerSchema',
  type: 'object',
  required: [
    'customerName',
    'customerNameSocial',
    'customerPhone',
    'customerEmail',
    'customerCitizenID',
    'customerPostalCode',
    'customerAddress'
  ],
  properties: {
    customerName: {
      type: 'string',
      minLength: 3
    },
    customerNameSocial: {
      type: 'string',
      minLength: 3
    },
    customerPhone: {
      type: 'string',
      minLength: 9,
      maxLength: 11,
      pattern: '^[0].*'
    },
    customerEmail: {
      type: 'string',
      pattern: '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+'
    },
    customerCitizenID: {
      type: 'string',
      minLength: 13,
      maxLength: 13
    },
    customerPostalCode: {
      type: 'string',
      minLength: 5,
      maxLength: 5
    },
    customerAddress: {
      type: 'string',
      minLength: 3
    }
  }
};

export default Customer;
